



















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { PowerPlan, PowerPlanDetails, PowerPlanEvent, PowerPlanEventType } from "@/services/powerPlans/types";
import { getPowerPlan, getPowerPlans } from "@/services/powerPlans/powerPlanService";
import vSelect from "vue-select";
import moment from "moment";
import { RecurenceEnum } from "@/services/posts/types";
import { isPowerPlanEventRecurring } from "@/services/powerPlans/powerPlanEventUtil";

@Component({
    components: {
        vSelect
    }
})
export default class SolutionPowerPlan extends Vue {
        @Prop() powerPlanId!: string;
        @Prop() collapseState!: boolean;
        @Prop() forceOn!: string;
        // local state
        localCollapseState = true;
        powerPlans = [] as PowerPlan[];
        powerPlan = {} as PowerPlanDetails;
        selectedPowerPlanId = null as string | null;
        currentEvent = {} as PowerPlanEvent;
        nextEvent = {} as PowerPlanEvent;
        types = PowerPlanEventType;
        localForceOn = "";
        // lifecycle hooks
        mounted() {
            this.localCollapseState = this.collapseState;
            this.localForceOn = this.forceOn;
            this.fetchData();
        }

        // computed
        get forceOnFormatted(): string {
            return moment(this.localForceOn).format("DD-MM-YYYY, HH:mm");
        }

        get timeIntervals(): string[] {
            const timeIntervals = [];
            const currentHour = moment(new Date()).hour();
            const startHour = currentHour + 1;
            for (let i = startHour; i < 24; i++) {
                timeIntervals.push(`${i < 10 ? 0 : ""}${i}:00`);
            }

            for (let i = 0; i <= currentHour; i++) {
                timeIntervals.push(`${i < 10 ? 0 : ""}${i}:00`);
            }

            return timeIntervals;
        }

        get powerPlanSettings() {
            if (!this.selectedPowerPlanId) {
                return "#";
            }
            return {
                name: "updatePowerPlan",
                params: { powerPlanId: this.selectedPowerPlanId }
            };
        }

        // methods
        fetchData() {
            getPowerPlans().then(response => {
                this.powerPlans = response;
            });
            if (this.powerPlanId) {
                getPowerPlan(this.powerPlanId).then(response => {
                    this.powerPlan = response;
                    this.selectedPowerPlanId = this.powerPlanId;
                    this.currentEvent = this.getCurrentEvent();
                    this.nextEvent = this.getNextEvent();
                });
            }
        }

        setState(state: boolean) {
            if (this.localCollapseState === state) return;

            this.localCollapseState = state;
            this.$emit("componentStateChanged", { name: "SolutionPowerPlan", state: state });
        }

        setForceOn(timeInterval: string) {
            const timeValues = timeInterval.split(":");
            const currentHour = moment(new Date()).hour();
            const selectedHour = Number(timeValues[0]);
            const date = currentHour >= selectedHour ? moment().add(1, "d") : moment();
            date.hour(selectedHour);
            date.minute(0);
            date.second(0);
            this.localForceOn = date.toDate().toLocaleString("en-US");
        }

        getCurrentEvent(): PowerPlanEvent {
            if (!this.powerPlan.events ||
                this.powerPlan.events.length === 0) {
                return {} as PowerPlanEvent;
            }
            const currentTime = moment();
            const currentEvent = this.powerPlan.events.slice().sort(function (a, b) {
                if (a.allDay === b.allDay) {
                    return 0;
                } else if (a.allDay) {
                    return 1;
                } else {
                    return -1;
                }
            }).find((powerPlanEvent) =>
                isPowerPlanEventRecurring(powerPlanEvent, currentTime));

            return currentEvent || {} as PowerPlanEvent;
        }

        getNextEvent() {
            if (!this.powerPlan.events ||
                this.powerPlan.events.length === 0) {
                return {} as PowerPlanEvent;
            }

            const events = this.currentEvent
                ? this.powerPlan.events.filter(ppe => ppe.id !== this.currentEvent.id)
                : this.powerPlan.events;

            const nextEvent = events.sort((a, b) =>
                moment(b.fromDate).unix() - moment(a.fromDate)
                    .unix())[0];

            return nextEvent || {} as PowerPlanEvent;
        }

        removeForceOn() {
            this.localForceOn = "";
        }

        emitData() {
            this.$emit("powerPlanUpdated", { powerPlanId: this.selectedPowerPlanId, forceOn: this.localForceOn });
        }
}
